import gql from "graphql-tag";

export const deleteBatchEventById = gql`
  mutation DeleteBatchEvent($id: ID) {
    deleteBatchEvent(where: { id: $id }) {
      id
    }
  }
`;
